
import { CategoryModal } from "@/components/categories/CategoryModal";
import { ContractTypeModal } from "@/components/contract-types/ContractTypeModal";
import { ContactModal } from "@/components/contacts/ContactModal";
import { CurrencyModal } from "@/components/currencies/CurrencyModal";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { useEnhancedTranslation } from "@/hooks/useEnhancedTranslation";

interface QuickAddFormModalsProps {
  contractTypeModalOpen: boolean;
  setContractTypeModalOpen: (open: boolean) => void;
  categoryModalOpen: boolean;
  setCategoryModalOpen: (open: boolean) => void;
  contactModalOpen: boolean;
  setContactModalOpen: (open: boolean) => void;
  currencyModalOpen: boolean;
  setCurrencyModalOpen: (open: boolean) => void;
  showUnsavedChangesDialog: boolean;
  setShowUnsavedChangesDialog: (show: boolean) => void;
  onConfirmNavigation: () => void;
  onCancelNavigation: () => void;
  onContractTypeCreated?: (contractType: any) => void;
  onCategoryCreated?: (category: any) => void;
  onContactCreated?: (contact: any) => void;
  onCurrencyCreated?: (currency: any) => void;
}

export function QuickAddFormModals({ 
  contractTypeModalOpen,
  setContractTypeModalOpen,
  categoryModalOpen,
  setCategoryModalOpen,
  contactModalOpen,
  setContactModalOpen,
  currencyModalOpen,
  setCurrencyModalOpen,
  showUnsavedChangesDialog,
  setShowUnsavedChangesDialog,
  onConfirmNavigation,
  onCancelNavigation,
  onContractTypeCreated,
  onCategoryCreated,
  onContactCreated,
  onCurrencyCreated
}: QuickAddFormModalsProps) {
  const { t } = useEnhancedTranslation();
  
  return (
    <>
      <ContractTypeModal 
        open={contractTypeModalOpen} 
        onOpenChange={setContractTypeModalOpen}
        // Pass onCreated as an unknown prop instead of directly
        {...(onContractTypeCreated ? { onCreated: onContractTypeCreated } : {})}
      />
      
      <CategoryModal
        open={categoryModalOpen}
        onOpenChange={setCategoryModalOpen}
        {...(onCategoryCreated ? { onCreated: onCategoryCreated } : {})}
      />
      
      <ContactModal
        open={contactModalOpen}
        onOpenChange={setContactModalOpen}
        onSuccess={onContactCreated || (() => {})}
      />
      
      <CurrencyModal
        open={currencyModalOpen}
        onOpenChange={setCurrencyModalOpen}
        {...(onCurrencyCreated ? { onCreated: onCurrencyCreated } : {})}
      />
      
      <AlertDialog open={showUnsavedChangesDialog} onOpenChange={setShowUnsavedChangesDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t('unsavedChanges', 'Unsaved Changes')}</AlertDialogTitle>
            <AlertDialogDescription>
              {t('unsavedChangesMessage', 'You have unsaved changes. Are you sure you want to leave this page? All changes will be lost.')}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={onCancelNavigation}>
              {t('stayOnPage', 'Stay on Page')}
            </AlertDialogCancel>
            <AlertDialogAction onClick={onConfirmNavigation}>
              {t('discardChanges', 'Discard Changes')}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
